module.exports = __webpack_public_path__ + "img/banner100.37210824.png";